import { useTranslation } from 'react-i18next'

interface RemakeConfirmDialogProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  isNewVersion: boolean
  isLoading?: boolean
}

export function RemakeConfirmDialog({ open, onConfirm, onCancel, isNewVersion, isLoading }: RemakeConfirmDialogProps) {
  const { t } = useTranslation()
  const r = (key: string) => t(`remake.${key}`)

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-white dark:bg-neutral-800 rounded-xl shadow-xl p-6 max-w-sm w-full mx-4">
        <h3 className="text-lg font-semibold text-neutral-900 dark:text-white mb-2">
          {r('confirmTitle')}
        </h3>
        <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-4">
          {isNewVersion ? r('confirmBody') : r('confirmBody')}
        </p>
        <div className="flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 text-sm rounded-lg text-neutral-600 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-700">
            {t('common.cancel')}
          </button>
          <button onClick={onConfirm} disabled={isLoading} className="px-4 py-2 text-sm rounded-lg bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed">
            {r('startButton')}
          </button>
        </div>
      </div>
    </div>
  )
}
